import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconTools from '@/icons/Tools.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { useGetArticleName } from '@/models/article';
import type { TNotificationOfType } from '@/models/notification';

export const ExchangeCanceledNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'exchange_canceled'>;
}) => {
  const { t } = useLingui();
  const getArticleName = useGetArticleName();

  const articleName = getArticleName({ article: notification.article });

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.exchange-cancelled.label',
        message: 'Exchange cancelled.',
      })}
      icon={<IconTools />}
      type="new"
      notification={notification}
      notificationHeader={(color) => (
        <InlineText weight="medium" color={color}>
          <Trans id="notification.exchange-cancelled">
            The exchange of item {articleName} has been cancelled.
          </Trans>
        </InlineText>
      )}
    />
  );
};
